<script setup lang="ts">
defineProps<{
  /** 現在のスライドインデックス */
  currentSlideIndex: number
}>();
</script>

<template>
<div class="box_step">
  <p class="num">{{ currentSlideIndex }} / 8</p>
  <ul :class="`step0${currentSlideIndex}`">
    <li
      v-for="step in 8"
      :key="step"
    ></li>
  </ul>
</div>
</template>
